import React, { useState } from "react";
import "./releaseNote.css";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { FaChevronCircleDown } from "react-icons/fa";

const ReleaseNotes = () => {
  const [showv12Feature1, setShowv12Feature1] = useState(true);
  const [showv12Feature2, setShowv12Feature2] = useState(false);

  const releaseNoteOne = require("../../assets/images/releaseNoteOne.png");
  const releaseNoteTwo = require("../../assets/images/releaseNoteTwo.png");
  const releaseNoteThree = require("../../assets/images/releaseNoteThree.png");
  const releaseNoteFour = require("../../assets/images/releaseNoteFour.png");
  const releaseNoteFive = require("../../assets/images/releaseNoteFive.png");
  const releaseNotesix = require("../../assets/images/releaseNoteSix.png");
  const releaseNoteSeven = require("../../assets/images/releaseNoteSeven.png");
  const releaseNoteEight = require("../../assets/images/releaseNoteEight.png");
  const releaseNoteNine = require("../../assets/images/releaseNoteNine.png");

  const releaseNoteTen = require("../../assets/images/releaseNoteTen.png");

  const toggleButtonOne = () => {
    setShowv12Feature1(!showv12Feature1);
  };

  const toggleButtonTwo = () => {
    setShowv12Feature2(!showv12Feature2);
  };

  return (
    <div className="release-notes mb-2">
      <div className="release-notes-content">
        <p className="title">Release Notes</p>
        {/* <div className="flex-box">
        <img src={releaseNoteImg} />
      </div> */}
        <div className="mt-4 margin-bottom">
          <Accordion defaultActiveKey={["0"]} alwaysOpen>
            <Accordion.Item eventKey="0">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                22-Jul-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v2
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Technicians not present in the selected site during the
                        job will be highlighted in red{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        As shown below the Technicians highlighted in red are
                        not present on the site during the job and hence need to
                        be removed from the job.
                        <div className="flex justify-between">
                          <img
                            src={releaseNoteOne}
                            className="wage-mapping-img w-45"
                          />
                          <img
                            src={releaseNoteTwo}
                            className="wage-mapping-img w-45"
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        On the click of any action button (Save, Hold, Reject or
                        validate), the below error message would be displayed.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteThree}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Terminated technicians will not be listed in the Field
                        app list of technicians and in the list of technicians
                        listed in the Allowances page
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        Only Active technicians will be listed out in the list
                        of technicians provided in the app.
                      </li>
                      <li className="releaseList">
                        In case a technician is terminated mid-month, he will
                        not be listed in any list after the exit date , while
                        jobs he worked at the beginning of the month will still
                        have his name and he is eligible for those incentives.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #3</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>Incentive % split up should be 100 %</strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        An error message indicating that the incentive % split
                        should add up to 100% as shown is displayed on the click
                        of any action button.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteFour}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        In case a technician is terminated mid-month, he will
                        not be listed in any list after the exit date , while
                        jobs he worked at the beginning of the month will still
                        have his name and he is eligible for those incentives.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #4</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        + sign to check logs of every job is displayed only
                        after a change or an action has been made to the job, by
                        the branch and HO{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        <div>
                          {" "}
                          <img
                            src={releaseNoteFive}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        As shown above, Job # 21098 does not have a + sign to
                        the left, indicating that no changes/action have been
                        made to that job yet.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #5</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        A loader has been added on the click of the Action
                        button in Allowances{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        <div>
                          {" "}
                          <img
                            src={releaseNotesix}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        To address the duplicate entries of technicians getting
                        added in slow networks, a loader has been added to
                        indicate completion of action to user.
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                05-Mar-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v10
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Allowance details and the Total incentive amount for the
                        Month are displayed in the My works page as shown below.{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        These values will appear only after the HO month
                        closure.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteSeven}
                            className="wage-mapping-img-height "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                08-Feb-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v9
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        In the My Works tab , as shown below, the Count
                        Displayed on the tile below Pulley lagging is the count
                        of jobs done by the technician and it will not include
                        the rejected jobs.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteEight}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        On the click of the Tile, you can see all the jobs with
                        its details, and this will include the rejected jobs
                        details also
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        As Shown below ,the expanded view of every job will also
                        highlight the current status of the job with the defined
                        icons given below .
                        <div>
                          {" "}
                          <img
                            src={releaseNoteNine}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #3</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        (% of incentive, Amount of incentive ) -listed for every
                        job in its expanded view will appear only after the HO
                        has authorized the job .
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #4</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        The sum total of all the incentives provided for all the
                        jobs for that particular type of job will be displayed
                        on the tile of that job type under the My Works section
                        .
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                02-Aug-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v8
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        Once a technician logs in, a loader will be shown below
                        to indicate that the page is loading and once done the
                        page will be ready for use.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteTen}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        If there are any unread notifications for that user, it
                        would take him to the Notification tab , if not New Job
                        tab will be his landing page as usual .
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReleaseNotes;
